import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { MatchProvider } from './context/MatchContext';
import DashboardPage from './components/DashboardPage';
import MainLayout from './components/MainLayout';
import VideoPage from './components/VideoPage';
import ComandPage from './components/ComandPage';
import SessionsPage from './components/SessionsPage';
import ReportPage from './components/ReportPage';
import AthletesPage from './components/AthletesPage';
import AthleteProfilePage from './components/AthleteProfilePage';
import MatchArchivePage from './components/MatchArchivePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home — Dashboard */}
        <Route path="/" element={<DashboardPage />} />

        {/* Analisi incontro */}
        <Route path="/analisi" element={
          <MatchProvider>
            <MainLayout />
          </MatchProvider>
        } />

        {/* Modalità 2 & 3: Finestra video standalone
            ?mode=dual  → Due Schermi PC (BroadcastChannel)
            ?mode=ipad  → PC+iPad (polling sync.php)           */}
        <Route path="/video"        element={<VideoPage />} />
        <Route path="/video-player" element={<VideoPage />} />

        {/* Modalità 3: Pannello comandi iPad */}
        <Route path="/comandi" element={<ComandPage />} />

        {/* Dashboard sessioni salvate (legacy) */}
        <Route path="/sessions" element={<SessionsPage />} />

        {/* Report analisi completa */}
        <Route path="/report/:id" element={
          <MatchProvider>
            <ReportPage />
          </MatchProvider>
        } />

        {/* Database atleti */}
        <Route path="/atleti" element={<AthletesPage />} />
        <Route path="/atleti/:name" element={<AthleteProfilePage />} />

        {/* Archivio incontri */}
        <Route path="/archivio" element={<MatchArchivePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
